import {App} from './app'
import 'firebase/auth'

var Auth = App.auth();
if(location.hostname === 'localhost') { 
	Auth.useEmulator('http://localhost:9099/');
}

export { Auth };